export enum DataType {
  Unknown = 0,
  Integer = 1,
  Boolean = 2,
  String = 3,
  DateTime = 4,
  Array = 5,
  Object = 6,
}
